import { Exception } from '../Exception';

export class ApplicationException extends Exception {
  originalException: unknown;
  constructor(message: string, originalException?: unknown) {
    super(message, originalException);
  }
}
